import type { User } from "@/lib/api/user";

export const INVITE_BLOCKER_LABELS = {
  email: "Email",
  phone: "Phone number",
  firstName: "First name",
  lastName: "Last name",
  birthday: "Birthday",
  sex: "Sex",
  billableGroup: "Billable group",
  notOnboarded: "Not onboarded",
  leadMentor: "Lead mentor",
} as const;

type InviteUser = Pick<
  User,
  | "email"
  | "phone"
  | "first_name"
  | "last_name"
  | "birthday"
  | "has_onboarded"
  | "assigned_groups"
  | "profile"
>;

export function getMentorInviteBlockers(
  user: InviteUser,
  { hasLeadMentor }: { hasLeadMentor: boolean },
): string[] {
  const blockers: string[] = [];

  if (!user.email?.trim()) blockers.push(INVITE_BLOCKER_LABELS.email);
  if (!user.phone?.trim()) blockers.push(INVITE_BLOCKER_LABELS.phone);
  if (!user.first_name?.trim()) blockers.push(INVITE_BLOCKER_LABELS.firstName);
  if (!user.last_name?.trim()) blockers.push(INVITE_BLOCKER_LABELS.lastName);
  if (!user.birthday) blockers.push(INVITE_BLOCKER_LABELS.birthday);
  if (!user.profile?.sex?.trim()) blockers.push(INVITE_BLOCKER_LABELS.sex);
  if (!user.assigned_groups?.some((group) => group.is_billable_group)) {
    blockers.push(INVITE_BLOCKER_LABELS.billableGroup);
  }
  if (user.has_onboarded === true) {
    blockers.push(INVITE_BLOCKER_LABELS.notOnboarded);
  }
  if (!hasLeadMentor) blockers.push(INVITE_BLOCKER_LABELS.leadMentor);

  return blockers;
}
